// Did not copy paste and screen shot code 
/* global globalThis */


import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { FiArrowLeft } from "react-icons/fi";
import BackToTop from "./BackToTop";
const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    // Disable right-click on images
    const handleContextMenu = (e) => {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
        toast.warning("Image download is disabled.");
      }
    };
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable copy
    const handleCopy = (e) => {
      e.preventDefault();
      toast.warning("Copying content is disabled.");
    };
    document.addEventListener("copy", handleCopy);

    // Disable Ctrl+S, Ctrl+U, Ctrl+C
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey && ["u", "s", "c"].includes(e.key.toLowerCase())) ||
        e.key === "PrintScreen"
      ) {
        e.preventDefault();
        toast.error("This action is not allowed.");
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    // Attempt to blank clipboard on PrintScreen
    const blankClipboard = async () => {
      try {
        await navigator.clipboard.writeText("Screenshots are disabled.");
        toast.warning("Screenshots are disabled.");
      } catch (err) {
        console.error("Failed to write to clipboard:", err?.message || err);
        toast.error("Unable to access clipboard.");
      }
    };

    const handleKeyUp = (e) => {
      if (e.key === "PrintScreen") {
        blankClipboard();
      }
    };
    globalThis.addEventListener("keyup", handleKeyUp);

    // Cleanup
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("keydown", handleKeyDown);
      globalThis.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-[#f9f7ef] overflow-hidden select-none">
      <ToastContainer position="top-center" autoClose={3000} />

      {/* {!isHomePage && (
        <>
          <img
            src={cornerImage1}
            alt="Top Left Decoration"
            className="absolute top-0 left-0 z-10 w-[120px] h-[140px] sm:w-[180px] sm:h-[200px] lg:w-[240px] lg:h-[279px] pointer-events-none"
            style={{ transform: "rotate(-360deg)", userSelect: "none" }}
          />
          <img
            src={cornerImage2}
            alt="Top Right Decoration"
            className="absolute top-0 right-0 z-10 w-[120px] h-[140px] sm:w-[180px] sm:h-[200px] lg:w-[240px] lg:h-[279px] pointer-events-none"
            style={{ userSelect: "none" }}
          />
        </>
      )} */}

      {/* Back Button */}
      {!isHomePage && (
        <button
          onClick={() => navigate(-1)}
          className="absolute top-8 left-4 sm:left-6 md:left-12 lg:left-20 w-10 h-10 flex z-10 items-center justify-center rounded-full bg-white shadow-md hover:bg-gray-100 transition"
          aria-label="Go back"
        >
          <FiArrowLeft className="w-5 h-5 text-black" />
        </button>
      )}


      {/* Page Content */}
      <div id="main-content" className="text-center font-canto">
        <Outlet />
      </div>
      <BackToTop />
    </div>
  );
};

export default Layout;
